import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.inputLabel)
    ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass(["d-control-input__label u-sel-none", {'d-control-input__label--active': $setup.isValue }]),
        for: $props.id
      }, [
        _createTextVNode(_toDisplayString($props.inputLabel), 1),
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}